<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Members</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0" >
        <table class="table table-sm align-items-center mb-0" >
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 " >
                Line Display</th>
                <!-- <button @click="sort_line_clicked()">Line Display / UID</button></th> -->
              <th v-if="is_extra"
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >สมาชิก</th>              
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ยอดเติม</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ส่วนแบ่ง</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Status</th>

              <!-- ><button @click="sort_status_clicked()">Status</button></th> -->
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.username">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6  class="mb-0 text-sm" @click="user_clicked(user)">{{user.line_display}}</h6>
                    <!-- <p class="text-xs text-secondary mb-0">{{user.username.slice(0,15) + " .."}}</p> -->
                  </div>
                </div>
              </td>

              <td v-if="is_extra" class="align-middle text-center">
                <button type="button" class="btn btn-info btn-icon" style="width:50px; text-align:center" 
                @click="user_clicked(user)">
                  {{user.t2.length}} 
                </button>
                <!-- <span class="text-secondary text-xs font-weight-bold">{{user.t2.length}}</span> -->
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-secondary text-xs font-weight-bold">{{user.total_amount}}</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{user.total_point}}</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">-</span>
              </td>
              
              <!-- <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{new Date(user.expire_date).toLocaleDateString('th-TH')  }} ({{user.balance_days}})</span>
              </td> -->

            </tr> 



          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
const qs = require('querystring')
var host_api=window.localStorage.getItem('$host_api');

export default {
  name: "referrers-table-extra",
  props:[
    // uid:String,
    // 'members'
  ],
  data() {
    return {
      users : [],
      username : "admin_jay",
      sort_type : 0,
      is_extra : false,
    }
  },
  methods :{ 
    user_clicked (user) {
      // console.log(user.t2)
      if ((user.t2.length > 0) && this.is_extra) {
        console.log('go')
        this.$store.state.t2 = user.t2
        this.$store.state.user2 = user
        this.$router.push('/t2');
        // this.users = user.t2
      }
      

    },
    reload_users(){           
      host_api=window.localStorage.getItem('$host_api');
      const config = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
      const requestBody = {
      }

      axios.post(host_api+"/admin/users/all", qs.stringify(requestBody), config,
        ).then(response => {
            if (response.data.status == "success") {
              // this.users = response.data.users
              if (this.uid != null && this.uid != '' && this.uid != undefined) {
                console.log('yes')
                response.data.users.forEach(user => {
                  if (user.ref_username == this.uid) {
                    user.balance_days = this.check_usage_days(user.expire_date) 
                    if (user.type == 0 )
                      user.type_str = "Member"
                    else if (user.type == 1)
                      user.type_str = "Influencer"
                    else 
                      user.type_str = "Unknown"
                    
                    if (user.line_display == '' || user.line_display == null || user.line_display == undefined) {
                      user.line_display = "[No Line Display]"
                      if (user.line_display.length > 15)
                        user.line_display = user.line_display.slice(0,15) + '..'
                    }

                    response.data.users.forEach(ref => {
                      if (user.ref_username == ref.username)
                        user.ref_str = ref.line_display
                    });
                    this.users.push(user)
                  }
                });
              } else { 
                console.log("no")
                response.data.users.forEach(user => {
                  user.balance_days = this.check_usage_days(user.expire_date) 
                  if (user.type == 0 )
                    user.type_str = "Member"
                  else if (user.type == 1)
                    user.type_str = "Influencer"
                  else 
                    user.type_str = "Unknown"
                  
                  if (user.line_display == '' || user.line_display == null || user.line_display == undefined) {
                    user.line_display = "[No Line Display]"
                  } else if  (user.line_display.length > 15) {
                    user.line_display = user.line_display.slice(0,15) + '..'
                  }

                  response.data.users.forEach(ref => {
                    if (user.ref_username == ref.username)
                      user.ref_str = ref.line_display
                  });
                  this.users.push(user)
                });
              }
            }
            else {
                console.log("False")
            }
        })
    }, 
    check_usage_days (expire_date) {
      var today =new Date()
      var lastday = new Date(expire_date)
      var difference = Math.floor((lastday - today) / (1000*60*60*24))
      difference = difference + 1
      if (difference < 0 )
        return 'expired'
      return difference + ' วัน'
    },

    sort_line_clicked (){
      this.sort_type = 0
    },
    sort_status_clicked (){
      this.sort_type = 2
    },

  },
  created() {
    
    this.users = this.$store.state.memo
    this.users.forEach(user => {
      if (user.total_amount > 0 || user.total_amount != null || user.total_amount != undefined){
        console.log(user.username)
      }
    });
    console.log(this.$store.state.memo)
    console.log(this.$store.state.type)
    if (this.$store.state.type == 'extra')
      this.is_extra = true
    else 
      this.is_extra = false
    this.users.forEach(user => {
      if(user.line_display == null || user.line_display == '' || user.line_display == undefined)
        user.line_display = '[No Display]'
      else if (user.line_display.length > 10)
        user.line_display = user.line_display.slice(0,10);
      if (user.total_amount == undefined) {
        user.total_amount = 0
      }
      if (user.total_point == undefined) {
        user.total_point = 0
      }
    });


  }, 
  computed: {
  }
};

</script>
